<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100">
      <defs>
        <clipPath id="clip-insta">
          <rect width="100" height="100"/>
        </clipPath>
      </defs>
      <g id="insta" clip-path="url(#clip-insta)">
        <g id="Groupe_3113" data-name="Groupe 3113" transform="translate(0.101 0)">
          <circle id="Ellipse_1061" data-name="Ellipse 1061" cx="5.865" cy="5.865" r="5.865" transform="translate(70.53 17.817)" :fill="color"/>
          <path id="Tracé_1866" data-name="Tracé 1866" d="M51.961,27.02a24.6,24.6,0,1,0,24.6,24.6A24.6,24.6,0,0,0,51.961,27.02Zm0,40.349A15.749,15.749,0,1,1,67.709,51.621,15.749,15.749,0,0,1,51.961,67.369Z" transform="translate(-1.613 -1.685)" :fill="color"/>
          <g id="Groupe_2287" data-name="Groupe 2287" transform="translate(-0.004)">
            <path id="Tracé_1867" data-name="Tracé 1867" d="M83.52,113.406H43.662a30.028,30.028,0,0,1-30-30V43.536a30.028,30.028,0,0,1,30-30h39.88a30.028,30.028,0,0,1,30,30v39.88A30.034,30.034,0,0,1,83.52,113.406ZM43.662,22.916a20.615,20.615,0,0,0-20.577,20.6v39.88a20.615,20.615,0,0,0,20.6,20.6H83.563a20.615,20.615,0,0,0,20.6-20.6V43.536a20.615,20.615,0,0,0-20.6-20.6H43.684Z" transform="translate(-13.666 -13.54)" :fill="color"/>
          </g>
        </g>
      </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'IconInstagram',
    mixins: [Colorable],
};
</script>
